export const ONBOARDING_KEYS = {
  statePicked: 'holiday-planner-state-picked',
  planHintSeen: 'holiday-planner-plan-hint-seen',
  firstTimeUser: 'holiday-app-first-time-user',
  checklistDismissed: 'holiday-planner-checklist-dismissed',
} as const;
